/**
 * Languages supported across the Shop & Smile web apps.
 *
 * English is always the source of truth. `fr` and `pt-PT` resources are
 * machine-translated by `scripts/i18n/translate.mjs` and are never edited
 * by hand (see AGENTS.md).
 */
export const supportedLanguages = ['en', 'fr', 'pt-PT'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

/**
 * Shared with every web app served from the same origin so the language
 * choice follows the user across products, main site and help center.
 */
export const LANGUAGE_STORAGE_KEY = 'shop-and-smile-language';

/**
 * Set once the stored language follows the signed-in user's saved language
 * (see `applyUserLanguage`). Cleared with the session on sign-out.
 */
export const LANGUAGE_SYNCED_KEY = 'shop-and-smile-language-synced';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const isSupportedLanguage = (
  value: string | null | undefined,
): value is SupportedLanguage =>
  supportedLanguages.includes(value as SupportedLanguage);
